import { Component } from '../common/componentUtils';
import { DataPreFilledType } from '../constants';
import { t } from '../utils';
import { DocgenClient } from './docgenClient';
import { handleErrorWithServerMessage } from './errorHandler';
import { DataSourceItem, Entity, Variable } from './interfaces/DocumentTemplate';
import { SchemaResponse } from './interfaces/SchemaResponse';

let entityMap = new Map<string, Entity[]>();
let isFetching = new Map<string, Promise<Entity[]>>();
let schemaMap = new Map<string, SchemaResponse>();
let dataSources = null;

export const fetchDataSources = async () => {
	if (dataSources) {
		return dataSources;
	}
	try {
		const response: DataSourceItem[] = await DocgenClient.getDataSources();
		dataSources = response;
		return response;
	} catch {
		handleErrorWithServerMessage(t('errorMessages.fetchDataSourcesError'));
	}
};
export const fetchEntitiesByDataSource = async (dataSourceConnectionRid: string) => {
	if (isFetching.has(dataSourceConnectionRid)) {
		return isFetching.get(dataSourceConnectionRid);
	}

	const promise = entityFetcher(dataSourceConnectionRid);
	isFetching.set(dataSourceConnectionRid, promise);
	return promise;
};

const entityFetcher = async dataSourceConnectionRid => {
	try {
		if (entityMap.has(dataSourceConnectionRid)) {
			return entityMap.get(dataSourceConnectionRid);
		}
		const entities: Entity[] = await DocgenClient.getEntitiesByDataSource(
			dataSourceConnectionRid
		);

		entityMap.set(dataSourceConnectionRid, entities);
		isFetching.delete(dataSourceConnectionRid);

		return entities;
	} catch {
		handleErrorWithServerMessage(t('errorMessages.fetchEntitiesError'));
		isFetching.delete(dataSourceConnectionRid);
	}
};
export const saveVariables = async (payload, rid) => {
	try {
		const response = await DocgenClient.updateDocumentTemplate(payload, rid);
		return response;
	} catch {
		handleErrorWithServerMessage(t('errorMessages.saveVariablesError'));
	}
};
export const fetchSchema = async (connectionRID, entityId) => {
	try {
		if (schemaMap.has(entityId)) {
			return schemaMap.get(entityId);
		}
		const schemaResponse: SchemaResponse = await DocgenClient.getSchema(
			connectionRID,
			entityId
		);

		schemaMap.set(entityId, schemaResponse);
		return schemaResponse;
	} catch {
		handleErrorWithServerMessage(t('errorMessages.fetchSchemaError'));
	}
};

export const updateFieldsOfVariable = (fields: Component[], variables: Variable[]) => {
	if (fields?.length && variables?.length) {
		const updatedFields = fields.map((field: Component) => {
			if (field.dataPreFilledType === DataPreFilledType.SourceMapped) {
				const { variableId, name } = field;
				const variable = variables.find(va => va.id === variableId);
				const [dataSource, , propertyName] = name.split('.');
				field.name = `${dataSource}.${variable?.name}.${propertyName}`;
			}
			return field;
		});

		return updatedFields;
	}
	return fields;
};

export const resetVariablesData = () => {
	entityMap = new Map<string, Entity[]>();
	isFetching = new Map<string, Promise<Entity[]>>();
	schemaMap = new Map<string, SchemaResponse>();
	dataSources = null;
};
